// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2NRDd","content":"GlobalSearch_content__3swQi"};